import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

interface ICurrencyDataTableProps {
  store: any;
  createAction?: () => void;
  rowActionsFn?: (...args: any[]) => DataTableRowActions;
  enableServerActions?: boolean;
  serverQuery?: DataTableServerQuery;
}

export const getCurrencyDataTableStructure = ({
  store,
  createAction,
  rowActionsFn,
  enableServerActions,
  serverQuery,
}: ICurrencyDataTableProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.currency.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };

  const codeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.currency.table.code',
    accessorKey: 'code',
    variant: DataTableColumnVariant.TEXT,
  };

  const descriptionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.currency.table.description',
    accessorKey: 'description',
    variant: DataTableColumnVariant.TEXT,
  };

  const tauxColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.currency.table.taux',
    accessorKey: 'taux',
    variant: DataTableColumnVariant.TEXT,
  };
  return {
    singular: 'settings.currency.table.singular',
    plural: 'settings.currency.table.plural',
    columns: [idColumn, codeColumn, descriptionColumn, tauxColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => {
      store.set('response', row);
      store.set('serverState', {
        code: row.code,
        description: row.description,
        taux: row.taux,
      });
      store.set('dto', {
        code: row.code,
        description: row.description,
        taux: row.taux,
      });
    },
    createAction,
    rowActionsFn,
    enableServerActions,
    serverQuery,
    searchableFields: ['id', 'code', 'description', 'taux'],
  };
};
